import * as CertificationWatermark from '@tableau/certification-watermark';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { ExplorerStyles } from '../../Explorer/ExplorerStyles';
import { StyledCellFormatter } from '../StyledCellWrapper';

export interface ContentTypeCellOptions {
  imageUrlForRow: (row: DataGrid.Row) => string;
  titleForIcon: (row: DataGrid.Row) => string;
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps;
}

export const ContentTypeCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {

          const src = options.imageUrlForRow(this.props.row);
          const icon = src === ''
            ? <></>
            : <img src={options.imageUrlForRow(this.props.row)} className={ExplorerStyles.ContentTypeCellImg}
              alt={options.titleForIcon(this.props.row)} title={options.titleForIcon(this.props.row)}/>;

          return (
              <div className={ExplorerStyles.ContentTypeCellContainer}>
                {icon}
              </div>
          );
        }
      })
  );
};
